module.exports = __webpack_public_path__ + "img/radio-to-cellular.97b914e4.svg";